import React from 'react';

class RowItemCongTacXayDung extends React.Component {

  render() {
    let Item = this.props.item;
    let data = Item ? Item.soLieuBaoCaoInfo : {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{data.tenDonVi}</td>

        <td className='txt-center'>{data.tongSo}</td>
        <td className='txt-center'>{data.soTTVCaoCapVaTuongDuong}</td>
        <td className='txt-center'>{data.soTTVChinhVaTuongDuong}</td>
        <td className='txt-center'>{data.soTTVVaTuongDuong}</td>
        <td className='txt-center'>{data.soCBCCVCTrongBienChe}</td>
        <td className='txt-center'>{data.soLaoDongHopDong}</td>
        <td className='txt-center'>{data.tiepNhanTuyenDung}</td>
        <td className='txt-center'>{data.nghiHuuChuyenCongTac}</td>
        <td className='txt-center'>{data.boNhiemChucVuLanhDao}</td>
        <td className='txt-center'>{data.boNhiemVaoNgachNangNgach}</td>
        <td className='txt-center'>{data.chuyenDoiViTriCongTac}</td>
        <td className='txt-center'>{data.viPhamKLPhaiXuLy}</td>
        <td className='txt-center'>{data.viPhamKLDaXuLy}</td>
        <td className='txt-center'>{data.tongSoNhuCau}</td>
        <td className='txt-center'>{data.tongSoDaThucHien}</td>
        <td className='txt-center'>{data.thanhTraVienNhuCau}</td>
        <td className='txt-center'>{data.thanhTraVienDaThucHien}</td>
        <td className='txt-center'>{data.thanhTraVienChinhNhuCau}</td>
        <td className='txt-center'>{data.thanhTraVienChinhDaThucHien}</td>
        <td className='txt-center'>{data.thanhTraVienCaoCapNhuCau}</td>
        <td className='txt-center'>{data.thanhTraVienCaoCapDaThucHien}</td>
        <td className='txt-center'>{data.daoTaoLyLuanChinhTri}</td>
        <td className='txt-center'>{data.daoTaoKhac}</td>
        <td className='ghi-chu'>{data.ghiChu}</td>
      </tr>
    );
  }
}

export default RowItemCongTacXayDung;


// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemCongTacXayDung.jsx